export default {
  cancel: 'Отменить счет',
  messages: {
    stripeWarning:
      'Оплата с помощью платежной системы Stipe доступна только на '
  }
};
